import { lazy } from 'react';

const SalesInvoiceScreen = lazy(() => import('../pages/QNE/SalesInvoice'));
const PurchaseInvoiceScreen = lazy(() =>
  import('../pages/QNE/PurchaseInvoice'),
);

const PaymentVoucherScreen = lazy(() => import('../pages/QNE/PaymentVoucher'));

const qneRoute = {
  public: [],
  auth: [
    {
      name: 'qne_sales_invoices',
      path: '/qne/sales-invoices',
      component: SalesInvoiceScreen,
    },
    {
      name: 'qne_purchase_invoices',
      path: '/qne/purchase-invoices',
      component: PurchaseInvoiceScreen,
    },
    {
      name: 'qne_payment_vouchers',
      path: '/qne/payment-vouchers',
      component: PaymentVoucherScreen,
    },
  ],
};

export default qneRoute;
